import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export const Bold = ({ children }: Props) => {
  return <strong style={{ fontWeight: 600 }}>{children}</strong>;
};
